/** Next Level public marketplace subdomain URL (see PublicHeader). */
export const NEXT_LEVEL_MARKETPLACE_URL = 'nlinvesting.housefolios.com'

export const NEXT_LEVEL_LOGO_SRC = '/images/next-level-logo.png'
export const NEXT_LEVEL_LOGO_ALT = 'Next Level'

export function isNextLevelMarketplace(marketplace) {
  return marketplace?.url === NEXT_LEVEL_MARKETPLACE_URL
}

/**
 * Logo props for Next Level public page headers.
 * Other marketplaces keep their existing Font Awesome / default icon chrome.
 */
export function getNextLevelLogoProps(marketplace) {
  if (!isNextLevelMarketplace(marketplace)) {
    return {
      logoSrc: undefined,
      logoAlt: undefined,
    }
  }

  return {
    logoSrc: NEXT_LEVEL_LOGO_SRC,
    logoAlt: NEXT_LEVEL_LOGO_ALT,
  }
}
